<template>
     <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h5>Tags with number</h5>
                    </div>
                    <div class="card-body"><a class="badge badge-primary" href="#">1</a><a class="badge badge-secondary" href="#">2</a><a class="badge badge-success" href="#">3</a><a class="badge badge-info" href="#">4</a><a class="badge badge-warning" href="#">5</a><a class="badge badge-danger" href="#">6</a><a class="badge badge-light text-dark" href="#">7</a><a class="badge badge-dark" href="#">8</a></div>
                </div>
            </div>
</template>